import { v4 as uuid } from "uuid";
import { PRODUCT_NAME } from "../constants/ApiEndpointConstants";
import LocalStorageUtil from "../utils/LocalStorageUtil";

// Refer to this documentatin for more: https://www.npmjs.com/package/uuid
const generateRandomString = (length) => {
  if (length) {
    return uuid().toString().substring(0, length);
  }

  return uuid();
};

const generateRandomEmail = (romajiName) => {
  if (romajiName) {
    romajiName = romajiName.toLowerCase().replaceAll(" ", "");
    const randomEmailSuffix = [
      "gmail.com",
      "yahoo.com",
      "icloud.com",
      "yahoo.co.jp",
      "ezweb.ne.jp",
      "ybb.ne.jp",
      "yahoo.ne.jp",
      "nmt.ne.jp",
      "ymail.ne.jp",
    ];
    const randomEmail =
      romajiName +
      uuid().toString().substring(0, 6) +
      "@" +
      randomEmailSuffix[Math.floor(Math.random() * randomEmailSuffix.length)];
    return randomEmail;
  }
  return romajiName;
};

const generateEventId = (eventName, productId) => {
  if (!eventName) {
    return this.generateRandomString(10);
  }

  // PageView   ViewContent CustomizeProduct  AddToCart  AddPaymentInfo  InitiateCheckout  Purchase
  // 匿名用户id
  let anonymousUserId = LocalStorageUtil.loadAnonymousUserId();
  if (!anonymousUserId) {
    anonymousUserId = uuid();
    LocalStorageUtil.saveAnonymousUserId(anonymousUserId);
  }
  let eventId = `${PRODUCT_NAME}-${anonymousUserId}-${eventName}`;
  if (productId) {
    eventId += `-${productId}`;
  }

  // 仅针对ViewContent 和 CustomizeProduct事件，ViewContent 一天一次，CustomizeProduct 一小时一次
  if (eventName === "ViewContent" || eventName === "CustomizeProduct") {
    const pageVisited = LocalStorageUtil.loadPageVisited(eventName);
    if (!pageVisited) {
      LocalStorageUtil.savePageVisited(eventName);
      eventId += `-${LocalStorageUtil.loadPageVisited(eventName)}`;
    } else {
      const now = new Date().getTime();

      if (eventName === "ViewContent") {
        if (now - parseInt(pageVisited) >= 1000 * 60 * 60 * 24) {
          LocalStorageUtil.savePageVisited(eventName);
          eventId += `-${LocalStorageUtil.loadPageVisited(eventName)}`;
        } else {
          eventId += `-${pageVisited}`;
        }
      } else {
        if (now - parseInt(pageVisited) >= 1000 * 60 * 60 * 1) {
          LocalStorageUtil.savePageVisited(eventName);
          eventId += `-${LocalStorageUtil.loadPageVisited(eventName)}`;
        } else {
          eventId += `-${pageVisited}`;
        }
      }
    }
  }

  return eventId;
};

const randomPrice = (max, min) => {
  let result = Math.floor(Math.random() * (max - min + 1)) + min;
  return result;
};

export {
  generateRandomString,
  generateRandomEmail,
  generateEventId,
  randomPrice,
};
